import type {Nullable} from '../../../utils/utility-types';
import type {ModelToProps} from '../Base/types';
import type {FileModel} from '../File/File.model';
import type {QuestionModel} from '../Question/Question.model';

import {BaseModel} from '../Base/Base.model';

const ModelName = 'AssessmentModel';

export class AssessmentModel extends BaseModel {
  avatar: Nullable<FileModel>;
  description = '';
  diagram: {
    points: {end: number; title: string}[];
    style: AssessmentModel.DiagramStyle;
  };
  questions: QuestionModel[];
  showDescriptionToClient: boolean;
  status: AssessmentModel.Status;
  timeToFill: string;
  title: string;

  constructor(props: AssessmentModel.Props) {
    super(props);
    Object.assign(this, props);
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace AssessmentModel {
  export enum DiagramStyle {
    BLUE = 'blue',
    GREEN_RED = 'green_red',
    RED_GREEN = 'red_green',
  }

  export enum Status {
    ACTIVE = 'active',
    ARCHIVED = 'archived',
    DELETED = 'deleted',
    HIDDEN = 'hidden',
  }

  export type Props = ModelToProps<AssessmentModel>;
}
